<template>
  <div class="feed-wrap">
    <span class="my-feed" @click="myfeedback">我要反馈</span>
    <Modal
      v-model="feedVisible"
      :hasFooter="false"
      title="我要反馈"
      :customFooter="false"
      :width="600"
      @on_cancel="closeModal"
    >
      <template slot="body">
        <a-textarea
          placeholder="欢迎您反馈使用产品过程中遇到的任何问题和建议，最多500字~"
          :rows="5"
          maxlength="500"
          v-model="feedContent"
        />
        <div class="subtn-wrapper ">
          <a-button type="primary" class="ant-btn sub-btn " @click="subFeed">
            提交
          </a-button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/enroll/Modal.vue'
import { msgTip } from '@/utils/urlUtils'
import { api_post, api_get } from '@/utils/http.ts'
import { loadFromLocal } from '@/utils/local'
import { sa } from '@/utils/sa'

export default {
  name: 'feedback',
  props: {
    msg: String,
    value: Boolean
  },
  data() {
    return {
      feedContent: '',
      feedVisible: false
    }
  },
  watch: {
    value: function(val) {
      if (val) {
        this.myfeedback()
      } else {
        this.feedVisible = false
      }
    },
    feedVisible: function(val) {
      if (val) {
        this.feedContent = ''
      }
    }
  },
  components: { Modal },
  methods: {
    myfeedback() {
      setTimeout(() => {
        sa.track('ContentRepository_Top', {
          lvevl1Menu: '我要反馈'
        })
      }, 50)
      this.feedVisible = true
    },
    closeModal() {
      this.feedVisible = false
      this.$emit('close')
    },
    async subFeed() {
      setTimeout(() => {
        sa.track('ContentRepository_Top', {
          lvevl1Menu: '我要反馈',
          lvevl2Menu: '提交'
        })
      }, 50)
      let rdata = await api_post('/search/api/home/feedback', {
        tel: loadFromLocal('net_username') || '',
        content: this.feedContent
      })
      if (rdata.success) {
        this.closeModal()
        msgTip({
          type: 'success',
          msg: rdata.msg || '提交成功'
        })
      } else {
        msgTip({
          type: 'error',
          msg: rdata.error || 'error'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.sub-btn {
  width: 260px;
  height: 40px;
}
.subtn-wrapper {
  margin: 20px 10px 10px;
  text-align: center;
}
.feed-wrap {
  cursor: pointer;
  position: relative;
  padding-right: 25px;
  display: inline-block;

  .my-feed {
    color: rgba(0, 0, 0, 0.65);
    width: 56px;
    height: 22px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    line-height: 22px;
  }
}
</style>
